import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { RouterModule, Routes } from '@angular/router';
import { MobileDialogComponent } from '../mobile-dialog/mobile-dialog.component';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'lib-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatDialogModule,
        MatButtonModule,
        RouterModule,
        MatIconModule
    ]
})
export class MobileMenuComponent {
  dialog = inject(MatDialog);

  showFiller = false;
  readonly routes = input.required<Routes>();

  openDialog() {
    this.dialog.open(MobileDialogComponent, {
      backdropClass: 'mobile-dialog-backdrop',
      position: {
        top: '0',
        left: '0',
      },
      width: '100vw',
      maxWidth: '100vw',
      panelClass: 'mobile-dialog',
      data: {
        routes: this.routes(),
      },
    });
  }
}
